import { Directive, Input } from "@angular/core";
import { IGetArbetsorderRequest } from "~app/features/planera/model/IGetArbetsorderRequest";
import { IPlaneraBasdataResponse } from "~app/features/planera/model/IPlaneraBasdataResponse";
import { ArbetsorderSearchTexts } from "./arbetsorder-search-texts";

@Directive()

export abstract class ArbetsorderSearchBase {
    @Input() searchFilter: IGetArbetsorderRequest;
    @Input() basdata: IPlaneraBasdataResponse;
    texts = ArbetsorderSearchTexts.texts;

    constructor() {
        // Tom konstruktor
    }

    abstract forceUpdateFilterChange(): void;

}
